import { render, staticRenderFns } from "./FileSelectInputBlock.vue?vue&type=template&id=987d370a"
import script from "./FileSelectInputBlock.vue?vue&type=script&lang=ts"
export * from "./FileSelectInputBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports